module.exports = require("swa-bootstrap-corporate-landing-home-page/corporate/corporate-landing-page-tab-navigation-hot-data");